import Vue from 'vue'
import {
  getPlanPart,
  isOnetimePlan,
  isDirectDelivery,
  isPickupDeliverySameTime,
} from '@/utils/planUtils';
import { FoldTypeSetting } from '@/consts/user';
import { StatusKey } from '@/consts/washRequest';
import {
  NINETY_MINUTES_IN_MILLISECONDS,
  TWO_HOURS_IN_MILLISECONDS,
  THREE_HOURS_IN_MILLISECONDS,
} from '@/consts/time';

export function formatFoldCost(washRequest) {
  if (washRequest.fold_weight_point <= 0) {
    return '';
  }
  const weightPoint = washRequest.fold_weight_point.toFixed(2).replace(/(\.\d)0$/, '$1');
  return `${weightPoint}／${washRequest.total_fold_cost_minutes}分`;
}

export const ONETIME_MAX_COUNT = 20;
export const PICKUP_MAX_COUNT = 20;

export function createWashRequestViewModel(washRequest, staff) {
  const ret = { ...washRequest }

  ret.staff_name1 = staff?.name1 || ''
  ret.staff_name2 = staff?.name2 || ''

  ret.direct_delivery = isDirectDelivery(washRequest.plan_id)

  ret.plan_info = getPlanPart(washRequest.plan_id)
  ret.isOnetimePlan = isOnetimePlan(washRequest.plan_id)
  if (ret.isOnetimePlan) {
    ret.size = '単発（45L）'
  }

  ret.stopped_user_status = false
  if (washRequest.status === 2) {
    // 集配別の場合は集荷日が一時停止日より前であれば要対応とする
    if (washRequest.stop_start_dt && !isPickupDeliverySameTime(washRequest.plan_id)) {
      const dtFormat = Vue.filter('dtFormat')
      const pickupDate = dtFormat(washRequest.sched_pickup_dt, 'yyyymmdd')
      const stopStartDate = dtFormat(washRequest.stop_start_dt, 'yyyymmdd')
      ret.stopped_user_status = pickupDate >= stopStartDate
    } else {
      ret.stopped_user_status = true
    }
  }

  ret.fold_cost = formatFoldCost(washRequest)
  ret.have_wash_type_setting = washRequest.wash_type_setting === 1
  ret.have_fold_type_setting = hasFoldTypeSetting(washRequest)

  return ret
}

export function getWashedOrPickedUpHighlightClass(washRequest) {
  // 洗濯済みより先のステータスは設定しない
  if (!washRequest || washRequest.result_delivery_dt || washRequest.result_fold_dt) {
    return '';
  }

  if (washRequest.result_wash_dt) {
    // 洗濯済
    if (washRequest.have_fold_type_setting) {
      return 'back_green';
    } else if (washRequest.have_wash_type_setting) {
      return 'back_blue';
    } else {
      return '';
    }
  } else if (washRequest.result_pickup_dt) {
    // 集荷済
    return getPickedUpHighlightClass(washRequest);
  }

  return '';
}

export function getPickedUpHighlightClass(washRequest) {
  // have_wash_type_settingはcreateWashRequestViewModelでboolean化済み
  const hasWashTypeSetting = washRequest.have_wash_type_setting === true
  // has_oil_treatmentはDBのtinyintをそのまま受け取るため整数比較
  const hasOilTreatment = washRequest.has_oil_treatment === 1

  // 種別が未選択でもオイル対応がありであれば紫色
  // 洗い方指定とオイル対応が両方ともありなら青と紫を左右半分ずつ
  if (hasWashTypeSetting && hasOilTreatment) return 'back_blue_purple'
  if (hasWashTypeSetting) return 'back_blue'
  if (hasOilTreatment) return 'back_purple'
  // 種別またはオイル対応が未選択(null)の場合は灰色
  if (washRequest.laundry_type === null || washRequest.has_oil_treatment === null) return 'back_gray'
  return ''
}

function hasFoldTypeSetting(washRequest) {
  return washRequest.fold_type_setting === FoldTypeSetting.ENABLED
}

export function shouldShowFoldTypeSettingConfirmation(washRequest) {
  return washRequest.status_key === StatusKey.WASHED && hasFoldTypeSetting(washRequest)
};

export function isBeforePickup(washRequest) {
  return washRequest.status_key === StatusKey.CREATED
}

export function isFolded(washRequest) {
  return washRequest.status_key === StatusKey.FOLDED
}

export function setScheduleFromDatetime(washRequest) {
  const schedulePickupDatetime = new Date(washRequest.sched_pickup_dt)
  const scheduleDeliveryDatetime = new Date(washRequest.sched_delivery_dt)
  const isPickupDeliverySameDay = schedulePickupDatetime.getFullYear() === scheduleDeliveryDatetime.getFullYear()
    && schedulePickupDatetime.getMonth() === scheduleDeliveryDatetime.getMonth()
    && schedulePickupDatetime.getDate() === scheduleDeliveryDatetime.getDate()

  if (isPickupDeliverySameDay) {
    // 当日配達の場合: 集荷は2時間前、配達は3時間前の時刻を表示する
    washRequest.sched_pickup_dt_from = new Date(schedulePickupDatetime.valueOf() - TWO_HOURS_IN_MILLISECONDS)
    washRequest.sched_delivery_dt_from = new Date(scheduleDeliveryDatetime.valueOf() - THREE_HOURS_IN_MILLISECONDS)
  } else {
    // 翌日以降配達の場合: 集荷は90分前の時刻を表示する
    washRequest.sched_pickup_dt_from = new Date(schedulePickupDatetime.valueOf() - NINETY_MINUTES_IN_MILLISECONDS)
  }
}
